import { validateOrderTripAddition } from '.'

import isUpcoming, { isOrderCurrent } from 'lib/order/isUpcoming'
import { sortOrdersByDeparture } from 'lib/order/orderUtils'

export function getFutureFilteredOrdersForChat(
  orders: Array<App.Order> = [],
): Array<App.Order> {
  return sortOrdersByDeparture(
    orders.filter(
      (order) =>
        (isUpcoming(order) || isOrderCurrent(order)) &&
        validateOrderTripAddition(order),
    ),
  )
}
